var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64645 0.149376C3.45118 0.344638 3.45118 0.661221 3.64645 0.856483L6.29289 3.50293H0.5C0.223857 3.50293 0 3.72679 0 4.00293C0 4.27907 0.223857 4.50293 0.5 4.50293H6.29289L3.64645 7.14938C3.45118 7.34464 3.45118 7.66122 3.64645 7.85648C3.84171 8.05175 4.15829 8.05175 4.35355 7.85648L7.85355 4.35648C8.04882 4.16122 8.04882 3.84464 7.85355 3.64938L4.35355 0.149376C4.15829 -0.0458859 3.84171 -0.0458859 3.64645 0.149376Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRightArrow);
export default __webpack_public_path__ + "static/media/small_right_arrow.220f8e38b05da23a13d52dedf40306b6.svg";
export { ForwardRef as ReactComponent };